import { AddressMediasTable } from "@/features/address-medias/address-medias-table";

export default function AddressMediasScreen() {
  return (
    <div className="p-4">
      <div className="mb-4">
        <h1 className="text-2xl font-bold">Address Medias</h1>
      </div>
      <AddressMediasTable />
    </div>
  );
}
